import elementTemplates from "bpmn-js-properties-panel/lib/provider/camunda/element-templates";
import diagramTranslate from "diagram-js/lib/i18n/translate";

import SmartPropertiesProvider from "./SmartPropertiesProvider";

export default {
  __depends__: [elementTemplates, diagramTranslate],
  __init__: ["propertiesProvider"],
  propertiesProvider: ["type", SmartPropertiesProvider],
};
